export default "__VITE_ASSET__5d20247e__"